import React from "react";
import SingleHealthStatus from "./SingleHealthStatus";

export default function HealthStatus({ patientId, patientDetail }) {
  console.log(patientDetail);
    return (
    <div className="healthStatusContent">
      <div className="">
        <h4>Patient Medical Status</h4>
      </div>

      <SingleHealthStatus title="Allergies" items={patientDetail?.allergies} />
      <SingleHealthStatus title="Symptoms" items={patientDetail?.symptoms} />
      <SingleHealthStatus title="Current Medication" items={patientDetail?.medication} />
      {/* <SingleHealthStatus title="Medical History / Condition" items={["Hypertension", "Hypertension", "Hypertension", "Hypertension"]} /> */}
    </div>
  );
}
